import {IElasticEventData, IStructuredLogger} from '../../../common/interfaces/structured-logging-service-interface';
import {MenuItemKey} from "../configurations/config-data-sections/generated-config-const";

export enum OrbitUserFlowAnalyticsCategory {
  Navigation = 'Navigation',
}

export enum OrbitUserFlowAnalyticsLabel {
  NavigationMenu = 'NavMenu',
  UserArea = 'UserArea',
  BottomNavigationBar = 'BottomNavBar',
}

export type OrbitUserFlowAnalyticsAction = MenuItemKey
                                           | string
                                           | 'myAccountButton' | 'withdrawButton' | 'depositButton';

export interface ISendElasticEventOptions  {
  eventType: string;
  category: string;
  action: string;
  label?: string;
  value?: string;
  customData?: object;
  appID?: string;
}

export interface IAnalyticsService {
  sendAnalytics(category: string, action?: string, label?: string, value?: any, omitStructuredLogger?: boolean): void;
  sendTechnicalEvent(action: string, label?: string, value?: any): void;
  sendElasticInfoEvent(options: ISendElasticEventOptions, sendToDWH?: boolean): void;
  sendOrbitUserFlowEvent(category: string | OrbitUserFlowAnalyticsCategory, action: OrbitUserFlowAnalyticsAction, label?: string | OrbitUserFlowAnalyticsLabel, value?: any): void;
  getLogger(eventData?: IElasticEventData): IStructuredLogger;
  getGoogleClientID(): string;
}



